module.exports = "/_next/static/images/harajuku_gyoretsu_cafe-3cf8f93dae1603cdf46e7a05ec567d6b.jpg";